import {NgModule} from "@angular/core";
import {FicAppTextPipe} from "./fic-app-text.pipe";

@NgModule({
    declarations: [
        FicAppTextPipe,
    ],
    exports: [
        FicAppTextPipe,
    ],
})
export class FicAppTextModule {

}
